// Errors
import VueRouter from 'vue-router';

export const PROBLEM_BASE_URL = 'https://www.jhipster.tech/problem';
export const EMAIL_ALREADY_USED_TYPE = `${PROBLEM_BASE_URL}/email-already-used`;
export const LOGIN_ALREADY_USED_TYPE = `${PROBLEM_BASE_URL}/login-already-used`;
export const FILE_USER_FORS = [
  { id: 'IMG', name: 'File ảnh' },
  { id: 'VIDEO', name: 'File video' },
  { id: 'MAP', name: 'File dữ liệu bản đồ' },
  { id: 'PLANNING', name: 'File quy hoạch' },
  { id: 'OTHER', name: 'File khác' },
];
export const MAP_TYPES = [
  { id: 'MAP_2D', name: '2D' },
  { id: 'VR360', name: 'VR360' },
  { id: 'MODEL_3D', name: '3D' },
  // { id: 'PLANNING', name: 'PLANNING' },
  // { id: 'TIMELAPSE', name: 'TIMELAPSE' },
];
export const FILE_PURPOSE = [
  { id: 'IMG', name: 'File Hình ảnh' },
  { id: 'VIDEO', name: 'File Video' },
  { id: 'GEODETIC', name: 'File Bản đồ' },
  { id: 'OTHER', name: 'File Khác' },
];
export const FILE_ACTIVATE = [
  { id: true, name: 'Chỉ file được kích hoạt' },
  { id: false, name: 'Chỉ file ẩn' },
];
export const CREATE_MAP = (arr: any[]) => {
  return CREATE_MAP_CUSTOM_KEY(arr, e => e.id);
};

export const CREATE_MAP_CUSTOM_KEY = (arr: any[] = [], keyMapper) => {
  const map = {};
  (arr || []).forEach((e, idx) => (map[keyMapper(e) || idx] = e));
  return map;
};
export const CREATE_MAP_KEY_TO_LIST_CUSTOM_KEY = (arr: any[] = [], keyMapper) => {
  const map = {};
  (arr || []).forEach((e, idx) => {
    const key = keyMapper(e) || idx;
    map[key] = map[key] || [];
    return map[key].push(e);
  });
  return map;
};

export function viewPageToQueryPage(page) {
  return { ...page, page: page.page - 1 };
}

export function getPageCount(page) {
  return Math.floor((page.total - 1) / page.size + 1);
}

export function routerPushSafer(router: VueRouter, to) {
  if (router.currentRoute.path !== to) router.push(to);
}

export function paramOptional(key, value, first = false) {
  if (value) {
    return `${first ? '?' : '&'}${key}=${value}`;
  } else {
    return '';
  }
}

export function humanFileSize(size: number) {
  const i = Math.floor(Math.log(size) / Math.log(1024));
  const number = size / Math.pow(1024, i);
  return number.toFixed(2) + ' ' + ['B', 'KB', 'MB', 'GB', 'TB'][i];
}
